import i18n, { Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-xhr-backend';

import en from '../assets/i18n/en.json';
import sc from '../assets/i18n/zh-Hans.json';
import tc from '../assets/i18n/zh-Hant.json';

const resources: Resource = {
  ['en']: { translation: en },
  ['zh-Hant']: { translation: tc },
  ['zh-Hans']: { translation: sc },
};

const defaultLang = 'en';
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(backend)
  .init({
    resources,
    keySeparator: '.',
    fallbackLng: defaultLang || 'en' || 'zh-hant',
    load: 'currentOnly',
    react: {
      wait: true,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      // order and from where user language should be detected
      order: ['path', 'querystring'],

      // keys or params to lookup language from
      lookupQuerystring: 'lang',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,

    },
  });
export default i18n;